import React, { useState } from 'react';
import { isPresent } from 'utils/helperMethods';
import { PropTypes } from 'prop-types';
import { Dialog, IconButton, Link, DialogContent, Typography } from '@material-ui/core';
import { Link as RouterLink, useLocation, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ResetPasswordForm from 'sharedComponents/ResetPasswordForm';
import Icon from 'sharedComponents/Icon';
import useScreen from 'hooks/useScreen';

import { GET_ENUMS } from 'const/router';
import useUpdatePassword from 'reducers/hooks/auth/useUpdatePassword';
import { getServerError } from 'utils/errors';
import { parseQueryParams } from 'utils/location';
import useStyles from './useStyles';

const ResetPassword = props => {
  const { onClose } = props;

  const location = useLocation();
  const history = useHistory();
  const { pathname } = location;
  const classes = useStyles();
  const { t } = useTranslation();
  const { isMobile } = useScreen();
  const { updatePassword } = useUpdatePassword();
  const [error, setError] = useState(null);

  const parsedQueryParams = parseQueryParams(location.search, { ignoreQueryPrefix: true, arrayFormat: 'bracket' });

  const handleSubmit = async values => {
    setError(null);
    try {
      await updatePassword(values, parsedQueryParams);
      history.push(`${pathname}?popup=${GET_ENUMS.popup.login}`);
    } catch (err) {
      const errors = getServerError(err);
      setError(errors);
    }
  };

  return (
    <div>
      <Dialog open onClose={onClose} fullScreen={isMobile}>
        <IconButton className={classes.dialogClose} onClick={onClose}>
          <Icon name="bigClose" />
        </IconButton>
        <DialogContent>
          <ResetPasswordForm onSubmit={handleSubmit} />
          {isPresent(error) && (
            <Typography className={classes.error} variant="body1" color="error">
              {error}
            </Typography>
          )}
          <div className={classes.links}>
            <Link
              to={{ pathname, search: `?popup=${GET_ENUMS.popup.login}` }}
              component={RouterLink}
              className={classes.link}
            >
              {t('components.ResetPassword.login')}
            </Link>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

ResetPassword.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default ResetPassword;



// WEBPACK FOOTER //
// ./src/components/ResetPassword/ResetPassword.js